import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import Footer1 from "../navbar/Footer1";
import "./Gallery.css";

const Gallery = () => {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch products from API
  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await fetch(
        "https://vogelkoparchitects.com/api/ecom/products/"
      );

      if (!response.ok) {
        throw new Error("Failed to fetch products");
      }

      const data = await response.json();
      setProducts(data);
    } catch (err) {
      console.error("Error fetching products:", err);
      setError("Failed to load products. Please try again later.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  // Handle product click - navigate to product detail page
  const handleProductClick = (productId) => {
    navigate(`/Productbydetail/${productId}`);
  };

  // Group products by group_code
  const groupedByGroupCode = products.reduce((acc, product) => {
    const groupCode = product.group_code || "Other";

    if (!acc[groupCode]) {
      acc[groupCode] = [];
    }

    acc[groupCode].push(product);
    return acc;
  }, {});

  // Loading state
  if (loading) {
    return (
      <div className="loading-container">
        <div className="loader"></div>
        <p>Loading products...</p>
      </div>
    );
  }

  // Error state
  if (error) {
    return (
      <div className="error-container">
        <p>{error}</p>
        <button onClick={fetchData} className="retry-button">
          Try Again
        </button>
      </div>
    );
  }

  // Empty state
  if (!products.length) {
    return (
      <div className="empty-state">
        <h2>No products found</h2>
        <p>There are no products available at the moment.</p>
      </div>
    );
  }

  return (
    <>
      <div className="gallery-banner">
        <div className="gallery-hero-bg">
          <div className="gallery-hero-overlay"></div>
        </div>
        <div className="gallery-hero-content">
          <h1 className="gallery-hero-title">Products</h1>
        </div>
      </div>

      <div className="gallery-container">
        <div className="products-main-container">
          {Object.keys(groupedByGroupCode).length > 0 ? (
            Object.entries(groupedByGroupCode).map(
              ([groupCode, productsInGroup]) => {
                return (
                  <div key={groupCode} className="main-code-section">
                    <h2 className="main-code-title">{groupCode}</h2>
                    
                    {/* 3 Cards per row grid layout - Works page style */}
                    <div className="gallery-grid">
                      {productsInGroup.map((product) => (
                        <div
                          key={product.id}
                          className="product-card"
                          onClick={() => handleProductClick(product.id)}
                        >
                          <div className="product-card-image">
                            <img
                              src={product.main_image || product.banner_image}
                              alt={product.product_name}
                              onError={(e) => {
                                e.target.src = "https://via.placeholder.com/400x300?text=No+Image";
                              }}
                            />
                            {/* Title in bottom-left corner of card */}
                            <div className="card-title-overlay">
                              <div className="card-group-code">{product.group_code}</div>
                              <h3 className="card-title">{product.product_name}</h3>
                            </div>
                            {/* Hover Overlay - Shows full description with arrow in bottom-right */}
                            <div className="product-card-overlay">
                              <div className="overlay-content">
                                <p className="overlay-description">
                                  {product.hint ? product.hint : "No description available"}
                                </p>
                                {/* Badges in overlay */}
                                {product.is_sold_out && (
                                  <div className="overlay-sold-out">Sold Out</div>
                                )}
                                {product.offer_type === "offer" && product.discount_percentage > 0 && (
                                  <div className="overlay-discount">{product.discount_percentage}% OFF</div>
                                )}
                                {/* Round Arrow Button - Bottom Right Corner */}
                                <div className="round-arrow">
                                  <svg 
                                    xmlns="http://www.w3.org/2000/svg" 
                                    viewBox="0 0 24 24" 
                                    fill="none" 
                                    stroke="currentColor" 
                                    strokeWidth="2" 
                                    strokeLinecap="round" 
                                    strokeLinejoin="round"
                                  >
                                    <line x1="5" y1="12" x2="19" y2="12"></line>
                                    <polyline points="12 5 19 12 12 19"></polyline>
                                  </svg>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                );
              },
            )
          ) : (
            <div className="no-products-message">
              <p>No products available.</p>
            </div>
          )}
        </div>
      </div>

      <Footer1 />
    </>
  );
};

export default Gallery;